import { CustomerOnboardingContainer } from 'components/shared/onboarding/CustomerOnboarding/CustomerOnboardingContainer';

export const CustomerOnboarding = (): JSX.Element => {
  return <CustomerOnboardingContainer />;
};
